// actions/eventActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getAllEvents =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "EVENT_REQUEST" });
      const { data } = await api.get("/events", { params });
      dispatch({ type: "GET_EVENTS_SUCCESS", payload: data.events });
    } catch (err) {
      dispatch({ type: "EVENT_FAIL", payload: err.response?.data?.message });
    }
  };

export const getCalendarData = (year, month) => async (dispatch) => {
  try {
    dispatch({ type: "CALENDAR_REQUEST" });
    const { data } = await api.get("/events/calendar", {
      params: { year, month },
    });
    dispatch({ type: "CALENDAR_SUCCESS", payload: data.calendar });
    return data.calendar;
  } catch (err) {
    dispatch({ type: "CALENDAR_FAIL", payload: err.response?.data?.message });
  }
};

export const createEvent = (eventData) => async (dispatch) => {
  try {
    dispatch({ type: "EVENT_REQUEST" });
    const { data } = await api.post("/events", eventData);
    dispatch({ type: "CREATE_EVENT_SUCCESS", payload: data.event });
  } catch (err) {
    dispatch({ type: "EVENT_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const updateEvent = (id, eventData) => async (dispatch) => {
  try {
    dispatch({ type: "EVENT_REQUEST" });
    const { data } = await api.put(`/events/${id}`, eventData);
    dispatch({ type: "UPDATE_EVENT_SUCCESS", payload: data.event });
  } catch (err) {
    dispatch({ type: "EVENT_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const deleteEvent = (id) => async (dispatch) => {
  try {
    dispatch({ type: "EVENT_REQUEST" });
    await api.delete(`/events/${id}`);
    dispatch({ type: "DELETE_EVENT_SUCCESS", payload: id });
  } catch (err) {
    dispatch({ type: "EVENT_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const sendEventNotification = (id) => async (dispatch) => {
  try {
    dispatch({ type: "EVENT_REQUEST" });
    await api.post(`/events/${id}/notify`);
    dispatch({ type: "EVENT_NOTIFY_SUCCESS", payload: id });
  } catch (err) {
    dispatch({ type: "EVENT_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};
